import React from "react";
import { render } from "react-dom";
import page from "page";
import GamesFilterHead from "../components/GamesFilterHead.jsx";
import GamesFilterNavigation from "../components/GamesFilterNavigation.jsx";
import GamesFilterGames from "../components/GamesFilterGames.jsx";
import gameFilter from "../helpers/gameFilter";
import PlayVideo from "../helpers/PlayVideo";
import moverAddHome from "../helpers/moverAddHome";
import noUnityChrome from "../helpers/noUnityChrome";
import lazyAdsense from "../helpers/lazyAdsense";

export default function () {
	if (document.referrer != window.location.href) {
		$("html,body").animate(
			{
				scrollTop: $(".Main").offset().top,
			},
			1000,
		);
	}

	lazyAdsense("#banner-970-bottom", 150, "section_center_1");
	// Filtrado de Juegos
	if (!paginationData.disable_ranking) {
		render(<GamesFilterHead />, document.getElementById("GamesFilterHead"));
	}

	render(
		<GamesFilterNavigation
			page={paginationData.page}
			totalPages={paginationData.totalPages}
		/>,
		document.getElementById("GamesFilterNavigation"),
	);
	page("/:first/:second", gameFilter);

	page("/:first/:second/:page", gameFilter);
	page();

	noUnityChrome();
	new PlayVideo();
	moverAddHome();
}
